import { useState } from "react";

import { Input, Text } from "@fragments";
import { SendTimeExtensionRounded } from "@mui/icons-material";

export default function Interactions({ configRef }) {
    const [enabled, setEnabled] = useState(
        configRef.current?.interactions_enabled
    );

    function handleChange(value) {
        configRef.current.interactions_enabled = value;
        setEnabled(value);
    }

    return (
        <>
            <Text.h3
                value="Publicações no grupo"
                className="mt-5 mb-1"
                grow
                left={<SendTimeExtensionRounded />}
            />

            <Text.h5
                grow
                contrast={5}
                value="Caso as interações estejam desabilitadas, membros não administradores não poderao publicar no grupo"
            />

            <Input.Switch
                value={enabled}
                onInput={handleChange}
                label="Permitir publicações"
            />
        </>
    );
}
